var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xk2hkfhtna)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.991 1.667c-4.6 0-8.325 3.733-8.325 8.333s3.725 8.334 8.325 8.334c4.608 0 8.342-3.734 8.342-8.334S14.599 1.667 9.99 1.667zm5.775 5h-2.458a13.043 13.043 0 0 0-1.15-2.967 6.691 6.691 0 0 1 3.608 2.967zm-5.767-3.3c.692 1 1.234 2.108 1.592 3.3H8.408c.358-1.192.9-2.3 1.591-3.3zm-6.45 8.3A6.868 6.868 0 0 1 3.333 10c0-.575.083-1.133.216-1.666h2.817c-.067.55-.117 1.1-.117 1.666 0 .567.05 1.117.117 1.667H3.549zm.684 1.667H6.69c.267 1.041.65 2.041 1.15 2.966a6.656 6.656 0 0 1-3.608-2.966zM6.69 6.667H4.233A6.656 6.656 0 0 1 7.84 3.7a13.04 13.04 0 0 0-1.15 2.967zm3.308 9.967a11.74 11.74 0 0 1-1.591-3.3h3.183a11.74 11.74 0 0 1-1.592 3.3zm1.95-4.967h-3.9A12.26 12.26 0 0 1 7.916 10c0-.566.058-1.125.133-1.666h3.9c.075.541.134 1.1.134 1.666 0 .567-.059 1.117-.134 1.667zm.209 4.633c.5-.925.883-1.925 1.15-2.966h2.458a6.691 6.691 0 0 1-3.608 2.966zm1.475-4.633c.066-.55.116-1.1.116-1.667 0-.566-.05-1.116-.116-1.666h2.816c.134.533.217 1.091.217 1.666s-.083 1.134-.217 1.667h-2.816z",
    fill: "#3A833C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xk2hkfhtna"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.adf44ff4ac4be85e63fcbf38115c5cd5.svg";
export { ForwardRef as ReactComponent };